import 'bootstrap'
import '../sass/index.scss'

import { setNavBarActiveLink } from './header'
import { fetchActivitiesEntertainment } from './helpers/api'
import { displayActivityItem } from './components/card-square-activity'
import { populateCampaigns } from './components/campaigns'
import { populateBlogPosts } from './components/posts'

import Search from './components/search'

/** @type Search */
let search
let ticking = false

async function populateHighlightedItems () {
  const itemsList = document.getElementById('highlights-list')
  if (itemsList) {
    const params = {
      page_size: 6,
      status: 'published'
    }
    const activities = await fetchActivitiesEntertainment(params)
    itemsList.textContent = ''
    activities.results.forEach((activity) => {
      itemsList.insertAdjacentHTML('beforeend', displayActivityItem(activity))
    })
  }
}

function adjustHomeContentsForScreenSize () {
  if (smallScreenContent()) {
    document.getElementById('highlights-title').textContent = 'Agenda'
    document.getElementById('campaigns-title').textContent = 'Planes'

    for (const label of document.getElementsByClassName('see-all-label')) {
      label.textContent = 'Ver todas'
    }
  }
}

async function initializeFilters () {
  search = new Search({ filters: ['collection'], alternateCollectionFilter: true })
  await search.init()
}

function hookScrollEvent () {
  document.getElementById('filters-container').addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        search.filterObjects.agesFilter.close()
        search.filterObjects.catFilter.close()
        ticking = false
      })
      ticking = true
    }
  })
}

function smallScreenContent () {
  return document.documentElement.clientWidth <= 768
}

document.addEventListener('DOMContentLoaded', () => {
  adjustHomeContentsForScreenSize()
  setNavBarActiveLink()
  initializeFilters()
  populateHighlightedItems()
  populateCampaigns()
  populateBlogPosts()
  hookScrollEvent()
})
